<template>
  <span class="support-enum-idarray" :class="icon"
    ><a v-if="count" @click.stop="click" class="label">{{
      (lang == 'CN' ? '查看(+' : 'view(+') + count + ')'
    }}</a></span
  >
</template>
<script>
export default {
  name: 'SupportEnumIDArray',
  props: {
    lang: String,
    scope: Object
  },
  computed: {
    defaultVal() {
      return this.$getPropValue(this.scope.row, this.scope.column.property)
    },
    // icon() {
    //   if (this.defaultVal == '√') {
    //     return 'el-icon-success'
    //   } else if (this.defaultVal == '×') {
    //     return 'el-icon-error'
    //   } else if (this.defaultVal == '※') {
    //     return 'el-icon-question'
    //   } else if (this.defaultVal && this.defaultVal.length > 1) {
    //     return 'idarray'
    //   } else {
    //     return 'el-icon-error'
    //   }
    // },
    icon() {
      if (this.defaultVal == '√') {
        return 'el-icon-success'
      } else if (this.defaultVal == '×') {
        return ''
      } else if (this.defaultVal == '※') {
        return 'el-icon-question'
      } else if (this.defaultVal && this.defaultVal.length > 1) {
        return 'idarray'
      } else {
        return ''
      }
    },
    count() {
      if (this.icon == 'idarray') {
        var arr = this.defaultVal.split(',')
        return arr.length
      }
      return 0
    }
  },
  methods: {
    click() {
      this.$emit('view', this.scope)
    }
  }
}
</script>
<style lang="less">
.support-enum-idarray {
  font-size: 20px;
  line-height: 20px;
  vertical-align: middle;
  &.el-icon-success {
    color: #67c23a;
  }
  &.el-icon-error {
    color: #f56c6c;
  }
  &.el-icon-question {
    color: #e6a23c;
  }
  .label {
    display: none;
  }
  &.idarray {
    .label {
      display: inline;
      color: #409eff;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
</style>
